export const categories = [
  {
    key: 'feiwen',
    name: '明星绯闻',
    desc: '聚焦明星情感动态与私下行程，第一时间追踪娱乐圈最受关注的绯闻线索。',
    icon: 'ri-user-heart-line',
  },
  {
    key: 'yingshi',
    name: '影视内幕',
    desc: '剧组换角、片场风波、投资纠纷，带你了解影视剧幕后的真实故事。',
    icon: 'ri-film-line',
  },
  {
    key: 'zongyi',
    name: '综艺爆料',
    desc: '剪辑争议、嘉宾矛盾、节目组内幕，综艺圈的花边与真相都在这里。',
    icon: 'ri-mic-line',
  },
  {
    key: 'wangluo',
    name: '网络传闻',
    desc: '热搜背后的传闻与反转，网络爆料真真假假，理性围观不带节奏。',
    icon: 'ri-chat-poll-line',
  },
  {
    key: 'mingxing',
    name: '明星动态',
    desc: '官宣、退团、合约、复出，记录明星事业发展中的每一次关键转折。',
    icon: 'ri-star-line',
  },
];

export const newsTags = ['娱乐圈新闻', '影视花边', '活动报道'];